module.exports = __webpack_public_path__ + "img/sl.300d5dd2.svg";